export class ExclusionMotive {
    id: number;
    name: string;
    active: boolean;;

}
